"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 *
 */
const react_1 = tslib_1.__importStar(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const carbon_components_react_1 = require("carbon-components-react");
const settings_1 = tslib_1.__importDefault(require("../settings"));
const { prefix } = settings_1.default;
const CLASS = `${prefix}-datePicker-component`;
// Carbon locales come from https://github.com/flatpickr/flatpickr/tree/master/src/l10n
// Even some of the locales supported by flatpickr are not supported in the Carbon version we have.
const carbonLocales = [
    'ar',
    'at',
    // 'az', // not supported in our version of Carbon
    'be',
    'bg',
    'bn',
    // 'bs', // not supported in our version of Carbon
    'cat',
    'cs',
    'cy',
    'da',
    'de',
    'en',
    'eo',
    'es',
    'et',
    'fa',
    'fi',
    // 'fo', // not supported in our version of Carbon
    'fr',
    // 'ga', // not supported in our version of Carbon
    'gr',
    'he',
    'hi',
    'hr',
    'hu',
    'id',
    // 'is', // not supported in our version of Carbon
    'it',
    'ja',
    // 'ka', // not supported in our version of Carbon
    // 'km', // not supported in our version of Carbon
    'ko',
    // 'kz', // not supported in our version of Carbon
    'lt',
    'lv',
    'mk',
    'mn',
    'ms',
    'my',
    'nl',
    'no',
    'pa',
    'pl',
    'pt',
    'ro',
    // 'ru', // not supported in our version of Carbon
    'si',
    'sk',
    'sl',
    'sq',
    // 'sr-cyr', // not supported in our version of Carbon
    'sr',
    'sv',
    'th',
    'tr',
    'uk',
    // 'uz', // not supported in our version of Carbon
    // 'uz_latn', // not supported in our version of Carbon
    'vn',
    // 'zh-tw', // not supported in our version of Carbon
    'zh',
];
class DatePicker extends react_1.Component {
    constructor(props) {
        super(props);
        // mapLocale is a fix for...
        // https://github.com/carbon-design-system/carbon/issues/7709
        this.mapLocale = locale => {
            let tempLocale = locale || '';
            while (tempLocale) {
                if (carbonLocales.includes(tempLocale)) {
                    break;
                }
                const suffixLocale = tempLocale.lastIndexOf('-');
                if (suffixLocale === -1) {
                    // no suffix locale to remove and no base locale matched
                    // default to English 'en'
                    tempLocale = 'en';
                    break;
                }
                tempLocale = tempLocale.slice(0, suffixLocale);
            }
            if (tempLocale !== locale) {
                console.warn(`Carbon does not support the locale ${(locale !== null && locale !== void 0 ? locale : 'undefined')}`);
                console.warn(`Using the locale ${tempLocale}`);
            }
            return tempLocale;
        };
        const { datePickerType, appendTo } = props;
        if (datePickerType === 'single' && !appendTo) {
            // If appendTo is not defined by the user, create a default appendTo that satisfies
            // the conditions for an appropriate flatpickr calendar container.
            const appendToDefault = document.createElement('div');
            appendToDefault.setAttribute('class', 'bx--date-picker-calendar-container');
            // The calendar must be attached to an element with a position !== 'static'.
            appendToDefault.style.position = 'fixed';
            appendToDefault.style.zIndex = '999';
            // Add the div to the state so that it can be picked up once this component mounts.
            this.state = { appendTo: appendToDefault };
        }
    }
    static getDerivedStateFromProps(props, state) {
        var _a;
        return {
            appendTo: props.appendTo || ((_a = state) === null || _a === void 0 ? void 0 : _a.appendTo),
        };
    }
    componentDidMount() {
        const { datePickerType, appendTo } = this.props;
        if (datePickerType === 'single' && !appendTo && this.state && this.state.appendTo) {
            react_dom_1.default.findDOMNode(this).appendChild(this.state.appendTo);
        }
    }
    render() {
        const _a = this.props, { 
        // remove - remapped
        'data-tid': dataTid, locale, 
        // remove - unused
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        appendTo } = _a, 
        // pass all other props to Carbon DatePicker
        otherDatePickerProps = tslib_1.__rest(_a, ['data-tid', "locale", "appendTo"]);
        const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS);
        const mappedLocale = this.mapLocale(locale);
        return (react_1.default.createElement(carbon_components_react_1.DatePicker, Object.assign({ appendTo: this.state.appendTo, "data-tid": mappedDataTid, locale: mappedLocale }, otherDatePickerProps)));
    }
}
exports.default = DatePicker;
DatePicker.propTypes = Object.assign({}, carbon_components_react_1.DatePicker.propTypes);
DatePicker.defaultProps = Object.assign({}, carbon_components_react_1.DatePicker.defaultProps);
